import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

/**
 * Component used to group together items within a card.
 *
 * **Base CSS Class:** `ph-form-group`
 */


export default function CoreFormGroup(props) {
	return (
		<div className={classnames('ph-form-group', props.className)}>
			{props.children}
		</div>
	);
}

CoreFormGroup.propTypes = {
	children: PropTypes.node,
	className: PropTypes.string
};
